import { Inject, Injectable } from '@angular/core';
import { NzMessageService, NzModalService } from 'ng-zorro-antd';
import { I18NService } from '@core/i18n/i18n.service';
import { ALAIN_I18N_TOKEN } from '@delon/theme';
import { NgForm } from '@angular/forms';
import { BizObjectParametersService } from '../../routes/jy-srm/biz-object-parameters/biz-object-parameters.service';
import { Observable } from 'rxjs';
import { BizObjectParameters } from '../../routes/jy-srm/biz-object-parameters/biz-object-parameters';
import { ReuseTabService } from '@delon/abc';
import { Router } from '@angular/router';
import { Sort } from '@core/bean/sort';
import { Direction } from '@core/bean/direction';
import { PersonService } from '../../routes/jy-org/person/service/person.service';
import { environment } from '@env/environment';
import {JyExtendService} from "../../routes/workflow/new-flow/newFlow.service";
import {InfoService} from "../../routes/jy-content/article/service/info.service";
import {DictService} from "../../routes/jy-dict/dict-info/service/dict.service";
import { JyExtendOverrideService } from '../../routes/workflow/new-flow/newFlowOverride.service';

const USER_TYPE_SUPPLIER = '0';


@Injectable({providedIn: 'root'})
export class CommonsService {
  //流程操作类型
  public COMMIT:string = "commit";
  public SAVE:string = "save";
  public BACK:string = "back";
  //工作流流程图base地址
  public workflowImgBase = environment.SERVER_URL + 'api/act/resource/read';
  public OaBase = environment.OA_SERVER_URL;
  //全局宽高
  public globalSize:any = {
    windowHeight: window.innerHeight,
    windowWidth: window.innerWidth,
    topHeight: 96,
    contentHeight: window.innerHeight - 185,//内容高度
    drawerHeight: window.innerHeight - 110,//抽屉内容高度
  };

  /**
   * 是否是内部人员
   */
  public isInner:boolean = false;
  count: number = 0;
  workFlowCount: number = 0;
  articleCount: any = 0;

  constructor(private modalService:NzModalService,
              private messageService:NzMessageService,
              private jyExtendOverrideService:JyExtendOverrideService,
              @Inject(ALAIN_I18N_TOKEN) private i18NService:I18NService,
              private bizObjectParametersService:BizObjectParametersService,
              private personService:PersonService,
              private reuseTabService:ReuseTabService,
              private jyExtendService: JyExtendService,
              private infoService: InfoService,
              private router:Router,
              private dictService:DictService
              ) {
    this.getGlobalSize();
  }

  getGlobalSize() {
    let that = this;
    window.onresize = function () {
      that.globalSize = {
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth,
        topHeight: 96,
        contentHeight: window.innerHeight - 185,//内容高度
        drawerHeight: window.innerHeight - 110,//抽屉内容高度
      };
    };
  }

  //路由复用replace跳转
  routerReplace(newUrl) {
    this.reuseTabService.replace(newUrl);
    setTimeout(() => {
      this.router.navigateByUrl(newUrl);
    },100);
  };

  get currentLang() {
    return this.i18NService.currentLang;
  }

  translate(key:string):string {
    return this.i18NService.fanyi(key);
  }


  showConfirm(str, nzOnOk, nzOnCancel?):void {
    this.modalService.confirm({
      nzTitle: this.translate(str),
      nzOnOk: () => nzOnOk(),
      nzOnCancel: () => {
        if (nzOnCancel) {
          nzOnCancel();
        }
      },
    });
  }

  showConfirmNew(str, str1, str2, str3, nzOnOk, nzOnCancel?): void {
    this.modalService.confirm({
      nzTitle: `<span style="color: yellow;">${this.translate(str)}</span>`,
      // nzTitle: this.translate(str),
      nzClassName: 'yellow-title',
      nzWidth: '25%', // 设置弹窗宽度
      nzStyle: {height: '50%'}, // 设置弹窗高度
      nzContent: `
      <div> <!-- 实现换行 -->
         <strong>${str3}</strong><br><br><strong>${str2}</strong><br><br><strong>${str1}</strong>
      </div>
    `,
      nzOnOk: () => nzOnOk(),
      nzOnCancel: () => {
        if (nzOnCancel) {
          nzOnCancel();
        }
      },
    });
  }

  showConfirmDelete(nzOnOk, nzOnCancel?) {
    this.modalService.confirm({
        nzTitle: this.translate('commons.info.askConfirmDelete'),
        nzOkType: 'danger',
        nzOnOk: () => nzOnOk(),
        nzOnCancel: () => {
          if (nzOnCancel) {
            nzOnCancel();
          }
        },
      }
    );
  }

  calTotalCount() {

  }

  /**
   * 获取消息数量
   */
  getArticleCount() {
    this.infoService.getUnreadCount().subscribe((data) => {
      this.articleCount = data;
      this.count = this.workFlowCount + this.articleCount;
    });
  }

  /**
   * 获取待办数量
   */
  getAgandaCount() {
    this.jyExtendOverrideService.sendBackLogOverride().subscribe((datas) => {
      this.workFlowCount = datas['totalCount'];
      this.count = this.workFlowCount + this.articleCount;
    });

  }

  getTotalCount(){
    this.getAgandaCount();
    this.getArticleCount();
  }

  showInfoMessage(str:string):void {
    this.messageService.info(this.translate(str),{nzDuration:5000});
  }

  showSuccessMessage(str:string):void {
    this.messageService.success(this.translate(str),{nzDuration:5000});
  }

  showWarningMessage(str:string):void {
    this.messageService.warning(this.translate(str),{nzDuration:5000});
  }

  showErrorMessage(str:string):void {
    this.messageService.error(this.translate(str),{nzDuration:5000});
  }

  /**
   *  获取当前人员
   */
  getCurrentPerson():any {
    return this.personService.currentPerson;
  }

  /**
   * 当前人员是否供应商
   */
  isSupplier(callBack: (result: boolean) => void) {
    let result: boolean;
    if (this.personService.currentPerson.id) {
      result = this.personService.currentPerson.user.userType == USER_TYPE_SUPPLIER;
      callBack(result);
    } else {
      this.personService.getCurrent().subscribe((data) => {
        this.personService.currentPerson = data;
        result = this.personService.currentPerson.user.userType == USER_TYPE_SUPPLIER;
        callBack(result);
      });
    }
  }

  /**
   * 获取业务对象参数，异步
   * @param key 业务对象key
   * @return 业务对象参数可观察对象
   */
  getBizObjectParameters(key:string):Observable<BizObjectParameters> {
    return this.bizObjectParametersService.getByKey(key);
  }


  //系统与之默认参数
  public systemDefaultParams: any = {};

  /**
   * 验证表单
   * @param form 表单
   */
  validate(form: NgForm): boolean {
    for (const i in form.controls) {
      form.controls[i].markAsDirty();
      form.controls[i].updateValueAndValidity();
    }
    return form.valid;
  }

  /**
   * 数组多字段排序
   * @param dataList 数组
   * @param sorts 排序
   */
  dataListSort(dataList:[any], sorts:Array<Sort>) {
    if (!dataList) {
      return dataList;
    }
    return dataList.sort((a, b) => {
      for (let i = 0; i < sorts.length; i++) {
        let sort = sorts[i];
        let flag = 1;
        if (sort.direction == Direction.DESC) {
          flag = flag * (-1);
        }
        if (a[sort.name] > b[sort.name]) {
          return 1 * flag;
        } else if (a[sort.name] < b[sort.name]) {
          return -1 * flag;
        }
      }
      return 0;
    });
  }

  //js中浮点数相乘问题
  accMul(arg1,arg2) {
    let m=0,s1=arg1.toString(),s2=arg2.toString();
    try{m+=s1.split(".")[1].length}catch(e){}
    try{m+=s2.split(".")[1].length}catch(e){}
    return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
  }

  //js浮点数相除问题
  div(a, b) {
    let c, d, e = 0,
      f = 0;
    try {
      e = a.toString().split(".")[1].length;
    } catch (g) {}
    try {
      f = b.toString().split(".")[1].length;
    } catch (g) {}
    return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), this.accMul(c / d, Math.pow(10, f - e));
  }

  /**
   * 存储服务器时间和本地时间差
   * */
  public poorTime:number = 0;

  /**
   * 存储常用计量单位转换关系
   * */
  public unitConverObj:any = {};
  getUnitConver(){
    this.unitConverObj = {};
    this.dictService.getWithItemList('unitconver').subscribe((res) => {
      if(res && res.dictItems && res.dictItems.length){
        res.dictItems.forEach((item) => {
          this.unitConverObj[item.code] = {
            value1:Number(item.value),
            value2:Number(item.value2)
          }
        })
      }
    })
  }

  /**
   * 获取转义后的文件连接
   */
  getEscapeUrl(file: {[key: string]: string}) {
    const map = new Map();
    map.set(" ", "%20");
    map.set("!", "%21");
    map.set("\"", "%22");
    map.set("#", "%23");
    map.set("$", "%24");
    map.set("%", "%25");
    map.set("&", "%26");
    map.set("'", "%27");
    map.set("(", "%28");
    map.set(")", "%29");
    map.set("*", "%2A");
    map.set("+", "%2B");
    map.set(",", "%2C");
    map.set("/", "%2F");
    map.set(":", "%3A");
    map.set(";", "%3B");
    map.set("<", "%3C");
    map.set("=", "%3D");
    map.set(">", "%3E");
    map.set("?", "%3F");
    map.set("@", "%40");
    map.set("[", "%5B");
    map.set("\\", "%5C");
    map.set("]", "%5D");
    map.set("^", "%5E");
    map.set("{", "%7B");
    map.set("|", "%7C");
    map.set("}", "%7D");
    map.set("~", "%7E");
    let newName: string = '';
    const len = file.name.length;
    for (let i  = 0; i < len; i++) {
      if (map.has(file.name.charAt(i))) {
        newName += map.get(file.name.charAt(i));
      } else {
        newName += file.name.charAt(i);
      }
    }
    if (file && file.url) {
      file.url = file.url.substring(0, file.url.length - file.name.length);
    }
    return file.url + newName;
  }
}
